import { Box, BoxProps, TextPreset } from '@facile-it/full-metal-ui/components'
import * as React from 'react'
import { ReactNode } from 'react'
import { Icon } from '..'
import * as styles from '../../styles/Pages.css'
import { DownloadableDocument } from './DownloadableDocument'

export interface DownloadableDocumentListProps extends Omit<BoxProps, 'title'> {
    items: Record<'href' | 'title', string>[]
    title: ReactNode
}

export const DownloadableDocumentList: React.FC<DownloadableDocumentListProps> = ({ items, title, ...boxprops }) => (
    <Box lineHeight="xl" position="relative" {...boxprops}>
        <TextPreset className={styles.otherBlue} component="p" preset="title-s" fontWeight="bold" paddingBottom="xxs">
            {title}
        </TextPreset>
        <Box component="ul" display="flex" flexDirection="column">
            {items.map((item, key) => (
                <li key={key}>
                    <DownloadableDocument {...item} key={key} />
                </li>
            ))}
        </Box>
        <Icon variant="download" className={styles.downloadIcon} alt="download" />
    </Box>
)
